var _polygon, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoComplianceCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_u30EC_u30A4_u30E4_u30FC_1",
    "data-name": "\\\\\\\\u30EC\\\\\\\\u30A4\\\\\\\\u30E4\\\\\\\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 17.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6.86 17.71 0 13.01 1.38 10.99 6.31 14.37 16.79 0 18.74 1.47 6.86 17.71",
    fill: "#1c4ec1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 15.35,
    width: 7.65,
    height: 2.41,
    fill: "#1c4ec1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.33,
    y: 11.18,
    width: 7.65,
    height: 2.41,
    fill: "#1c4ec1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.35,
    y: 7.01,
    width: 7.65,
    height: 2.41,
    fill: "#1c4ec1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComplianceCheck);
export default __webpack_public_path__ + "static/media/ico_compliance_check.8f8cfbf5fa41690c34b74d370e115d70.svg";
export { ForwardRef as ReactComponent };